import React, { useState } from "react";
import { FiUploadCloud, FiTarget } from "react-icons/fi"; // 图标库
import structureIcon from "./assets/GIF-pred.gif";

export default function PredictCif() {
  const [cifText, setCifText] = useState("");
  const [target, setTarget] = useState("band_gap");
  const [loading, setLoading] = useState(false);
  const [prediction, setPrediction] = useState(null);
  const [error, setError] = useState("");

  const handlePredict = async () => {
    if (!cifText.trim()) {
      setError("Please enter CIF or POSCAR structure content");
      return;
    }
    setError("");
    setLoading(true);
    setPrediction(null);

    try {
      const res = await fetch(
        `/predict/predict_text?input_format=cif&target=${target}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ structure_text: cifText }),
        }
      );

      if (!res.ok) throw new Error(`请求失败: ${res.status}`);

      const data = await res.json();
      setPrediction(data.prediction + " " + (data.unit || ""));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto bg-white p-6 rounded-2xl shadow-lg border border-gray-200">
      {/* 顶部标题和介绍 */}
     <div className="flex items-center space-x-3 mb-4">
  <h2 className="text-2xl font-bold text-gray-800">Structure-property prediction</h2>
  <img
    src={structureIcon}
    alt="Loading animation"
    className="w-5 h-5"
  />
</div>
      <p className="text-gray-600 mb-6">
        Please paste the material structure file content below (support CIF or POSCAR format),
        select the prediction target, and the system will return the model-predicted property values
      </p>

      {/* 结构输入区域 */}
      <div className="mb-6">
        <h3 className="font-semibold text-gray-700 mb-2 flex items-center">
          <FiUploadCloud className="mr-2" /> Please paste the material structure file content here:
        </h3>
        <textarea
          value={cifText}
          onChange={(e) => setCifText(e.target.value)}
          placeholder="example：# generated using pymatgen
data_C
_symmetry_space_group_name_H-M   'P 1'
_cell_length_a   3.667100
_cell_length_b   3.667100
_cell_length_c   3.667100
_cell_angle_alpha   90.000000
_cell_angle_beta   90.000000
_cell_angle_gamma   90.000000
_symmetry_Int_Tables_number   1
_chemical_formula_structural   C
_chemical_formula_sum   C8
_cell_volume   49.313774
_cell_formula_units_Z   8
loop_
 _symmetry_equiv_pos_site_id
 _symmetry_equiv_pos_as_xyz
  1  'x, y, z'
loop_
 _atom_site_type_symbol
 _atom_site_label
 _atom_site_symmetry_multiplicity
 _atom_site_fract_x
 _atom_site_fract_y
 _atom_site_fract_z
 _atom_site_occupancy
  C  C0  1  0.125000  0.625000  0.625000  1
  C  C1  1  0.875000  0.375000  0.375000  1
  C  C2  1  0.625000  0.625000  0.125000  1
  C  C3  1  0.375000  0.375000  0.875000  1
  C  C4  1  0.125000  0.125000  0.125000  1
  C  C5  1  0.875000  0.875000  0.875000  1
  C  C6  1  0.625000  0.125000  0.625000  1
  C  C7  1  0.375000  0.875000  0.375000  1"
          rows={600}
          className="w-full p-3 border rounded-lg font-mono text-sm focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* 选择预测目标 */}
      <div className="mb-6">
        <h3 className="font-semibold text-gray-700 mb-2 flex items-center">
          <FiTarget className="mr-2" /> Please select the prediction target:
        </h3>
        <select
          value={target}
          onChange={(e) => setTarget(e.target.value)}
          className="p-2 border rounded-lg"
        >
          <option value="band_gap">Band Gap</option>
          <option value="young_modulus">Young's Modulus</option>
          <option value="heat_capacity">Heat Capacity(300K)</option>
        </select>
      </div>

      {/* 预测按钮 */}
      <button
        onClick={handlePredict}
        disabled={loading}
        className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? "Predicting..." : "Start prediction"}
      </button>

      {/* 错误提示 */}
      {error && <p className="text-red-500 mt-4">{error}</p>}

      {/* 预测结果 */}
      {prediction && (
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <span className="font-semibold text-green-800">predict value: </span>
          <span className="text-green-700">{prediction}</span>
        </div>
      )}
    </div>
  );
}